__turbopack_context__.v({
  "ant-modal-body": "kWaagq_ant-modal-body",
  "ant-modal-content": "kWaagq_ant-modal-content",
  "bgModal": "kWaagq_bgModal",
  "bgModalL": "kWaagq_bgModalL",
  "bgModalUnBookmarked": "kWaagq_bgModalUnBookmarked",
  "btn": "kWaagq_btn",
  "btnComment": "kWaagq_btnComment",
  "btnFooter": "kWaagq_btnFooter",
  "btnPosition": "kWaagq_btnPosition",
  "btnRegisterLogin": "kWaagq_btnRegisterLogin",
  "btnlogin": "kWaagq_btnlogin",
  "card": "kWaagq_card",
  "cards": "kWaagq_cards",
  "content": "kWaagq_content",
  "divbtn": "kWaagq_divbtn",
  "gridContainer": "kWaagq_gridContainer",
  "gridItem": "kWaagq_gridItem",
  "headContact": "kWaagq_headContact",
  "icon-text-aligned": "kWaagq_icon-text-aligned",
  "p": "kWaagq_p",
  "p1": "kWaagq_p1",
  "pModal": "kWaagq_pModal",
  "page-body-wrap": "kWaagq_page-body-wrap",
  "paragraph": "kWaagq_paragraph",
  "paragraph-content": "kWaagq_paragraph-content",
  "paragraphKomen": "kWaagq_paragraphKomen",
  "slider": "kWaagq_slider",
  "sosmed": "kWaagq_sosmed",
  "store": "kWaagq_store",
  "t": "kWaagq_t",
  "title": "kWaagq_title",
  "titleModal": "kWaagq_titleModal",
  "wrap-container": "kWaagq_wrap-container",
  "wrap-content": "kWaagq_wrap-content",
});
